import { render, staticRenderFns } from "./AggLogs.vue?vue&type=template&id=0624518c&scoped=true"
import script from "./AggLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./AggLogs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AggLogs.vue?vue&type=style&index=0&id=0624518c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0624518c",
  null
  
)

export default component.exports